import _ from "lodash";
import * as Tag from "@/helper/characteristic/Tag";
import {TYPE__FUNCTION__ORGANISATIONAL_AREA} from "@/helper/characteristic/Correlation";
import {filterLastLevel} from "@/helper/characteristic/Characteristic";
import {flatten} from "@/helper/characteristic/Flatten";

export function isEligible (functions)
{
	if (!functions)
	{
		return false;
	}

	return _
		.filter(
			functions,
			characteristic => Tag.hasTag(characteristic, Tag.FUNCTION_ORGANISATIONAL_AREA_ELIGIBLE)
		)
		.length > 0;
}

export function filterItems (meta, functions)
{
	let items = meta.organisationalArea;

	let relevantFunctions = _.cloneDeep(filterLastLevel(functions));

	let shouldFilter = true;
	let relevantIds = [];

	relevantFunctions.forEach(functionItem =>
	{
		const characteristic = functionItem.item;
		const correlations = characteristic.correlations.filter(
			correlation => correlation.type === TYPE__FUNCTION__ORGANISATIONAL_AREA
		);

		// do not filter if one of last level does not have correlations
		if (correlations.length === 0)
		{
			shouldFilter = false;
			return false; // continue
		}

		correlations.forEach(correlation =>
		{
			if (!relevantIds.includes(correlation.target.id))
			{
				relevantIds.push(correlation.target.id);
			}
		});
	});

	if (!shouldFilter)
	{
		return items;
	}

	return items.filter(item => relevantIds.includes(item.id));
}

export function clearSelected (selected, meta, functions)
{
	const hadItems = selected.length > 0;

	const possibleOrganisationalAreaIds = flatten(filterItems(meta, functions))
		.map(item => item.id);

	selected = selected.filter(
		item => possibleOrganisationalAreaIds.includes(item.item.id)
	);

	if (hadItems && selected.length === 0)
	{
		selected = undefined;
	}

	return selected;
}
